import React, { Component } from "react";
import { connect } from "react-redux";
import ProductRatingSection from "./ProductRatingSection";
import ProductPriceList from "./ProductPriceList";
import ProductVariants from "./variants/ProductVariants";
import ProductBuyBtn from "./ProductBuyBtn";

import sanitizeHtml from "sanitize-html";

import "./../../css/product-info.css";
import "./../../css/form-fields.css";

// Utils
import getInventory from '../../utils/inventoryUtils';
import { unloadSelectedVariants } from '../../store/actions/productVariant';

class ProductContent extends Component {
	constructor(props) {
		super(props);

		this.state = {
			quantity: 1
		};

		this.quantityChange = this.quantityChange.bind(this);
	}

	quantityChange(event) {
		this.setState({ quantity: event.target.value });
	}

	renderShippingExempt(product) {
		if (product.shipping_exempt) {
			return (
				<div className="section shipping-exempt-section">
					<span className="icon-remove_shopping_cart" />
					Pickup item
				</div>
			);
		}
	}

	render() {
		const product = this.props.product;
		const variant = this.props.variant;
		const structure = this.props.structure;
		
		console.log('=== ProductContent Render ===');
		console.log('Product SKU:', product.sku);
		console.log('Variants Selected:', this.props.variantsSelected);
		console.log('Product variant_skus:', product.variant_skus);
		
		let inventory;
		
		// For products with variants, try to find the matching variant_sku
		if (product.variant_skus && product.variant_skus.length > 0) {
			
			// Filter variant selections to only include those that belong to current product
			const validVariantSelections = this.props.variantsSelected ? 
				this.props.variantsSelected.filter(vs => {
					// Check if this variant selection belongs to current product
					// by seeing if the option_id exists in any of the current product's variants
					return product.variants && product.variants.some(variant => 
						variant.items && variant.items.some(item => item.id === vs.option_id)
					);
				}) : [];
			
			console.log('Valid variant selections for this product:', validVariantSelections);
			
			// If we have valid selected variants, use those
			if (validVariantSelections.length > 0) {
				const selectedOptionIds = validVariantSelections.map(vs => vs.option_id);
				console.log('Valid selected option IDs:', selectedOptionIds);
				
				const matchingVariantSku = product.variant_skus.find(vs => {
					return vs.ids && vs.ids.length === selectedOptionIds.length && 
						   vs.ids.every(id => selectedOptionIds.includes(id));
				});
				
				if (matchingVariantSku) {
					inventory = matchingVariantSku.inventory;
					console.log('Using selected variant inventory:', inventory);
				} else {
					// No matching variant found, use first variant as default
					inventory = product.variant_skus[0].inventory;
					console.log('No match found, using first variant inventory:', inventory);
				}
			} else {
				// No valid variants selected, use first variant as default
				inventory = product.variant_skus[0].inventory;
				console.log('No valid variants selected, using first variant inventory:', inventory);
			}
		} else {
			// No variants, use base product inventory
			inventory = getInventory(product, undefined);
			console.log('No variant_skus, using base inventory:', inventory);
		}
		
		console.log('Final inventory value:', inventory);

		return (
			<div className="product_info_section">
				{/* Title */}
				<h1>{product.title}</h1>
				<div className="model_number">Item #{product.sku}</div>

				{/* Prices */}
				{this.props.siteInfo.prices_shown && (
					<div className="prices">
						<ProductPriceList
							product={product}
							siteinfo={this.props.siteInfo}
							mainProduct={!!this.props.mainProduct ? this.props.mainProduct : 0}
						/>
					</div>
				)}

				{/* Shipping exempt */}
				{this.renderShippingExempt(product)}

				{/* Description */}
				<div
					className="product_description"
					dangerouslySetInnerHTML={{ __html: sanitizeHtml(product.description) }}
				/>

				{/* Rating */}
				<ProductRatingSection product={product} />

				{/* Limited Stock Notification */}
				{inventory != null && inventory <= 5 && inventory > 0 && <div className="limited_stock_notification">{`Limited Quantity: ${inventory} In Stock`}</div>}
				{inventory != null && inventory <= 0 && <div className="limited_stock_notification">{`Out of Stock`}</div>}

				{/* Variants */}
				<ProductVariants product={product} />

				{/* Quantity */}
				<div className="quantity_container">
					<div className="option_title">Quantity:</div>
					<input
						className="qty"
						type="number"
						min="1"
						step="1"
						placeholder="0"
						defaultValue={this.state.quantity}
						onChange={this.quantityChange}
					/>
				</div>

				{/* Add to cart */}
				<ProductBuyBtn
					product={product}
					structure={structure}
					quantity={this.state.quantity}
				/>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		variant: state.productVariant.variant,
		variantsSelected: state.productVariant.variant_options
	};
};

export default connect(mapStateToProps, { unloadSelectedVariants })(ProductContent);



// WEBPACK FOOTER //
// ./src/components/product/ProductContent.js